(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bm-mobile-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bm-mobile-menu')) {
    customElements.define('bm-mobile-menu', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-menu-open]');
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-menu-open')) {
            this.previousOverflow = document.documentElement.style.overflow;
            document.documentElement.style.overflow = 'hidden';
            this.dialog.showModal();
            this.trigger.setAttribute('aria-expanded', 'true');
          } else if (button.hasAttribute('data-menu-close')) this.dialog.close();
          else if (button.hasAttribute('data-department')) this.selectDepartment(button);
          else if (button.hasAttribute('data-panel-open')) {
            const department = button.closest('.bm-mm-department');
            department.querySelector('.bm-mm-root').hidden = true;
            const panel = this.querySelector('[id="' + button.dataset.panelOpen + '"]');
            panel.hidden = false;
            this.lastPanelButton = button;
            this.querySelector('.bm-mm-body').scrollTop = 0;
            panel.querySelector('button').focus();
          } else if (button.hasAttribute('data-panel-back')) {
            button.closest('.bm-mm-sub').hidden = true;
            button.closest('.bm-mm-department').querySelector('.bm-mm-root').hidden = false;
            this.lastPanelButton?.focus();
          }
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus();
        });
        this.querySelector('.bm-mm-tabs').addEventListener('keydown', (event) => {
          const tabs = [...this.querySelectorAll('[data-department]')];
          let index = tabs.indexOf(event.target);
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = tabs.length - 1;
          else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          this.selectDepartment(tabs[index]);
          tabs[index].focus();
        });
        this.media = matchMedia('(min-width: 750px)');
        this.onResize = () => { if (this.media.matches && this.dialog.open) this.dialog.close(); };
        this.media.addEventListener('change', this.onResize);
      }
      disconnectedCallback() {
        this.media?.removeEventListener('change', this.onResize);
        if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.previousOverflow || ''; }
      }
      selectDepartment(button) {
        this.querySelectorAll('[data-department]').forEach(tab => {
          const selected = tab === button;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.querySelector('[id="' + tab.getAttribute('aria-controls') + '"]').hidden = !selected;
        });
        this.querySelectorAll('.bm-mm-sub').forEach(panel => panel.hidden = true);
        this.querySelectorAll('.bm-mm-root').forEach(panel => panel.hidden = false);
        this.querySelector('.bm-mm-body').scrollTop = 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    const bmHoverGalleryMedia = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  let bmHoverGalleryFrame = 0;
  let bmHoverGalleryTarget = null;
  let bmHoverGalleryX = 0;

  function bmHoverGallerySelect(gallery, index) {
    const scroller = gallery.querySelector('slideshow-slides');
    const slides = gallery.querySelectorAll('slideshow-slide:not([hidden])');
    if (!scroller || !slides[index]) return;
    const left = scroller.scrollLeft + slides[index].getBoundingClientRect().left - scroller.getBoundingClientRect().left;
    scroller.scrollTo({ left, behavior: 'instant' });
  }

  document.addEventListener('pointermove', (event) => {
    if (!bmHoverGalleryMedia.matches || event.pointerType !== 'mouse') return;
    const gallery = event.target.closest('.bm-four-image-gallery');
    if (!gallery || event.target.closest('button, slideshow-controls, quick-add-component')) return;
    bmHoverGalleryTarget = gallery;
    bmHoverGalleryX = event.clientX;
    if (bmHoverGalleryFrame) return;
    bmHoverGalleryFrame = requestAnimationFrame(() => {
      bmHoverGalleryFrame = 0;
      const target = bmHoverGalleryTarget;
      if (!target?.isConnected) return;
      const dots = target.querySelectorAll('.bm-card-gallery-dots button');
      if (dots.length < 2) return;
      const bounds = target.getBoundingClientRect();
      const index = Math.max(0, Math.min(dots.length - 1, Math.floor((bmHoverGalleryX - bounds.left) / bounds.width * dots.length)));
      if (dots[index].getAttribute('aria-selected') !== 'true') bmHoverGallerySelect(target, index);
    });
  }, { passive: true });

  document.addEventListener('pointerout', (event) => {
    if (!bmHoverGalleryMedia.matches || event.pointerType !== 'mouse') return;
    const gallery = event.target.closest('.bm-four-image-gallery');
    if (!gallery || (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget))) return;
    if (bmHoverGalleryTarget === gallery) {
      cancelAnimationFrame(bmHoverGalleryFrame);
      bmHoverGalleryFrame = 0;
      bmHoverGalleryTarget = null;
    }
    const firstDot = gallery.querySelector('.bm-card-gallery-dots button');
    if (firstDot && firstDot.getAttribute('aria-selected') !== 'true') bmHoverGallerySelect(gallery, 0);
  }, { passive: true });
  } catch(e) { console.error(e); }
})();

})();
